import React from "react";
import "./Alumini_Voices.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import Main_heading_holder from "../../common_components/main_heading_holder/Main_heading_holder";

const Alumini_Voices = () => {
  const stories = [
    {
      name: "Nikhil Londhe",
      role: "Online MBA Student",
      rating: 5,
      text: "Profcyma is an excellent education consultancy! The team is professional, transparent, and always ready to help. They guided me step-by-step through the admission process and suggested the best university for my career goals. Highly recommend their services to anyone looking for genuine guidance in online and distance education.",
    },
    {
      name: "Sneha Patil",
      role: "Online MBA Student",
      rating: 4,
      text: "Very smooth admission support. Profcyma helped with EMI options, documentation and fast enrollment.",
    },
    {
      name: "Vanita Gurav",
      role: "Online MBA Student",
      rating: 4,
      text: "The best place for online education guidance! Profcyma helped me shortlist the right MBA course based on my career interest. Thank you for your support.",
    },

    {
      name: "Shatrughan Prajapati",
      role: "Online MBA Student",
      rating: 5,
      text: "Exceptional assistance provided by your employee, Shivani Maam, throughout my MBA admission process.She did a fantastic job in assisting me at every step. Her guidance and support were invaluable, and I am very grateful for her dedication.",
    },
    {
      name: "Mohit Ingle",
      role: "Online MBA Student",
      rating: 4,
      text: "“Profcyma made my online MBA admission journey effortless! The team guided me at every step and helped me choose the best university for my career goals.”",
    },
    {
      name: "Vikas Kumar",
      role: "Online MBA Student",
      rating: 4,
      text: "The team guided me throughout my degree. I secured a better job with a higher package after completion.",
    },
  ];
  return (
    <section className="Alumini_Voices">
      {/* <div className="col_header">
        <p className="why_text">Alumni Voices</p>
        <h5 className="col_title">Stories of Transformation</h5>
      </div> */}

      <Main_heading_holder
        // heading="Testimonials"
        spanHeading=" Testimonials"
        headingType="h2"
      />

      <Swiper
        modules={[Autoplay]}
        spaceBetween={30}
        slidesPerView={3}
        // autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        breakpoints={{
          0: { slidesPerView: 1 },
          576: { slidesPerView: 2 },
          768: { slidesPerView: 2 },
          1200: { slidesPerView: 3 },
          1700: { slidesPerView: 4 },
        }}
        className="stories-slider"
      >
        {stories.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="story-card">
              <div className="rating">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span
                    key={star}
                    className={star <= item.rating ? "star filled" : "star"}
                  >
                    ★
                  </span>
                ))}
              </div>

              <p className="story-text">“{item.text}”</p>

              <div className="story-user">
                <span className="name">{item.name}</span>
                <span className="role">{item.role}</span>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Alumini_Voices;
